import BaseActionButton from "@components/controls/buttons/BaseActionButton";
import {useTranslation} from "react-i18next";
import {VivoPortal} from "@utils/AppConstants";
import {FlintActionButtonProps} from "@components/controls/buttons/FlintActionButtonProps";
import EnumIconButtonDefaultType = VivoPortal.EnumIconButtonDefaultType;

export default function FlintButton_Accept(props:FlintActionButtonProps) {
    const {t} = useTranslation();
    const {buttonText = t("Accept"), themeColor="primary", ...other} = props;
    return <BaseActionButton iconEnum={EnumIconButtonDefaultType.Accept} themeColor={themeColor} {...other}>
        {buttonText}
    </BaseActionButton>
}

